import React from 'react';
import styled from 'styled-components';
import { XCloseIcon } from '@rsos/assets/icons';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text, Absolute } from '@rsos/components/capstone/base';

export const WrapperContainer = styled(Box).attrs({
  bg: 'background',
  borderRadius: 5,
  height: 74,
})`
  border: ${p =>
    p.error
      ? `1px solid ${p.theme.colors.lightDanger}`
      : `1px solid ${p.theme.colors.heavyLineOutline}`};
  padding: 5px 5px 0;
`;

export const ULTagContainer = styled.ul`
  margin: 0;
  padding: 0;
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  overflow: auto;
`;

export const LiTagContainer = styled.li`
  align-items: center;
  font-size: 12px;
  height: 22px;
  background: ${p => (p.isValid ? p.theme.colors.foreground : 'inherit')};
  border-radius: ${p => (p.isValid ? '10px' : 'none')};
  color: ${p => p.theme.colors.secondaryText};
  display: flex;
  text-decoration: ${p => (p.isValid ? 'none' : 'underline dotted red')};
  list-style: none;
  margin-bottom: 5px;
  margin-right: 5px;
  margin-left: ${p => (p.isValid ? '5px' : 0)};
  padding: 0 23px 0 8px;
  position: relative;
`;

export const InputContainer = styled(Box).attrs(({ isValid }) => ({
  align: 'center',
  mb: '5px',
  mr: '5px',
  borderRadius: isValid ? '5px' : 'none',
  color: isValid ? 'background' : 'primaryText',
  padding: 10,
}))`
  flex-grow: 1;
`;

export const StyledMultiEntryTextArea = styled.textarea`
  background: none;
  color: ${p => p.theme.colors.secondaryText};
  width: 100%;
  font-size: 12px;
  border: none;
  resize: none;
  &::placeholder {
    color: ${p => p.theme.colors.secondaryText};
  }
  &:focus {
    outline: none;
  }
`;

export const InputTextLabel = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
  mb: '8px',
})``;

export const ClearIconComponent = ({ onClick }) => {
  return (
    <Absolute
      top={0}
      bottom={0}
      center
      width="16px"
      right={0}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <XCloseIcon width={9} height={9} />
    </Absolute>
  );
};

export const ErrorComponent = ({ error }) => {
  return (
    <Box horizontal flow={5} color="lightDanger" mt="8px">
      <AttentionTriangleIcon height={12} width={12} />
      <Text size="small" color="lightDanger">
        {error}
      </Text>
    </Box>
  );
};
